import { ArnConditionOpts } from './ArnConditionOpts';

export enum ArnPredefinedConditionTemplate {
  HasArianeeSmartAsset = 'HasArianeeSmartAsset',
  HasERC721 = 'HasERC721',
  IsWhitelisted = 'IsWhitelisted',
  MatchHttpResponse = 'MatchHttpResponse',
  SPKZ = 'SPKZ',
}

export type ArnConditionTemplate = ArnPredefinedConditionTemplate | string;

export interface ArnCondition {
  readonly templateName: ArnConditionTemplate;
  opts: ArnConditionOpts;
}
